import _ from "lodash";
import basketItem from "./components/basket-item/index.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import navigateTo from "../../../../mixins/buy-flow";
import { debounce } from "lodash";
import { formatPrice } from "@/helpers";

export default {
  name: "buy-flow",
  mixins: [navigateTo],
  data() {
    return {
      kod: "",
      showBonusesInput: false,
      bonusesAmount: 0,
      disabledButton: false,
      width: window.innerWidth,
      loader: true,
    };
  },
  components: {
    basketItem,
  },
  async created() {
    await Promise.all([
      this.sync(),
      this.runCheckOrderGiftAndSamplers(),
      this.getClientPrices()
    ])

    if (this.hasUnselectedGifts) {
      this.changeSelectGiftPopup(true);
    }

    const transformedProducts = this.basket.map((item) => {
      return {
        item_id: item.productPrices.data[0].article,
        item_name: item.title,
        affiliation: "SkinOn-Cosmetics",
        coupon: '',
        discount: 0.00,
        index: 0,
        item_brand: item.brand?.title || 'SkinOn',
        item_category: item.brandSeries?.title || '',
        item_category2: (() => {
          if (!this.isAuthenticated) return 'unauthorized'
          if (this.isProfessional) return 'professional'
          if (this.isDistributor) return 'distributor'
          return 'regular'
        })(),
        item_list_id: "Cosmetics",
        item_list_name: "Cosmetics",
        location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
        price: item.productPrices.data[0].price,
        quantity: item.select_count,
      }
    })

    const sum = this.basket.reduce((acc, item) => {
      return acc + item.productPrices.data[0].price;
    }, 0);

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "view_cart",
      ecommerce: {
        currency: "UAH",
        value: parseFloat(sum).toFixed(2),
        items: transformedProducts
      }
    });

  },
  watch: {
    bonusesAmount() {
      this.setBonuses({ pay_bonus_amount: this.bonusesAmount });
      this.$refs.bonusesError.innerHTML = "";
      this.disabledButton = false;

      if (this.bonusesAmount > this.user?.bonusAmount) {
        this.$refs.bonusesError.innerHTML = `доступно ${this.user.bonusAmount + " бонусів"}`;
        this.disabledButton = true;
      }
    },
    earnedGiftCount(next, prev) {
      // New gifts became available — prompt the user to choose.
      if (next > prev && this.hasUnselectedGifts) {
        this.changeSelectGiftPopup(true);
      }
    },
  },
  computed: {
    ...mapGetters({
      basket: "basket/basket",
      isDistributor: "profile/isDistributor",
      isProfessional: "profile/isProfessional",
      isUserWithCode: "profile/isUserWithCode",
      saleProducts: "order/saleProducts",
      user: "profile/user",
      isAuthenticated: "auth/isAuthenticated",
      giftGroups: "order/giftGroups",
      selectedGifts: "order/selectedGifts",
      earnedGiftCount: "order/earnedGiftCount",
      selectedGiftCount: "order/selectedGiftCount",
      hasUnselectedGifts: "order/hasUnselectedGifts",
      samplerProducts: "order/samplerProducts",
      productsWithDefaultPrices: "basket/productsWithDefaultPrices",
    }),
    priceType() {
      return this.bonusesAmount > 0 ? 'basePrice' : 'price'
    },
    selectedGiftPreview() {
      // Flatten selectedGifts into displayable rows by looking up the variant.
      const rows = [];
      this.selectedGifts.forEach(item => {
        const group = this.giftGroups.find(g => g.id === item.giftGroupId);
        if (!group) return;
        const variant = group.products.find(v => v.productPriceId === item.productPriceId);
        if (!variant) return;
        rows.push({
          ...item,
          title: variant.product.title,
          image: variant.product.image,
        });
      });
      return rows;
    },
    checkBasketContainsPromotion() {
      return (
        this.basket.findIndex(
          product => product.select_type.hasActivePromotion || product.select_type.hasIndividualDiscount
        ) !== -1
      );
    },
    totalSum() {
      let bonusesAmount = this.bonusesAmount <= this.user?.bonusAmount ? this.bonusesAmount : 0;

      return _.sumBy(this.basket, product => product.select_type[this.priceType] * product.select_count) - bonusesAmount;
    },
    getTempDiscount() {
      return this.hasTempDiscount() ? (this.totalSum * 5) / 100 : 0;
    },
    discount() {
      if (!this.canSeeDiscount()) return 0;

      let sum = 0;

      this.basket.forEach(basketProduct => {
        if (!this.productsWithDefaultPrices) return;
        if (basketProduct.select_type.oldPrice) {
          sum += basketProduct.select_type.oldPrice - basketProduct.select_type.price
        }
        // const foundProduct = this.productsWithDefaultPrices.find(product => {
        //   return product.id === basketProduct.id;
        // });
        //
        // const clientPrice = foundProduct.productPrices.data.find(defaultPriceProduct => {
        //   return defaultPriceProduct.value === basketProduct.select_type.value;
        // });

        // if (!clientPrice) return;
        // let discount = 0;
        // const price = basketProduct.select_type;
        // if (this.isProfessional) {
        //   if (price.hasIndividualDiscount) {
        //     discount = price.oldPrice - price.price;
        //   }
        // } else if (this.isDistributor) {
        //   discount = clientPrice.price - price.price;
        // } else {
        //   sum += (clientPrice.price - price.price) * basketProduct.select_count;
        //   return;
        // }

        // sum += discount * basketProduct.select_count;
      });

      return sum;
    },
  },
  methods: {
    formatPrice,
    ...mapActions({
      getSyncBasket: "basket/GET_SYNC_BASKET",
      fetchDefaultPrices: "basket/GET_DEFAULT_PRICE_BASKET",
      updateUserAssignCode: "profile/UPDATE_USER_DATA",
      fetchUser: "profile/FETCH_USER_DATA",
      checkSale: "order/CHECK_SALE",
      checkGift: "order/CHECK_GIFT",
      checkSampler: "order/CHECK_SAMPLER",
      getClientPriceBasket: "basket/GET_CLIENT_PRICE_BASKET",
    }),
    ...mapMutations({
      changeLoginPopup: "popups/CHANGE_LOGIN_POPUP",
      changeSelectGiftPopup: "popups/CHANGE_SELECT_GIFT_POPUP",
      setBonuses: "basket/SET_USER_BONUSES",
      morphBasket: "basket/MORPH_BASKET",
    }),
    async runCheckOrderGiftAndSamplers() {
      try {
        let products = {};
        this.loader = true;
        this.basket.map(item => {
          products[item.select_type.id] = item.select_count;
        });

        const formattedProducts = Object.fromEntries(
          Object.entries(products).map(([key, value]) => [`products[${key}]`, value])
        );

        await Promise.all([
          this.checkGift(formattedProducts),
          this.checkSampler(formattedProducts),
          this.checkSale(formattedProducts),
          // this.sync()
        ]);
        this.morphBasket(this.saleProducts);
      } catch (e) {
        console.error(e);
      } finally {
        this.loader = false;
      }
    },
    checkOrderGiftAndSamplers: debounce(function () {
      return this.runCheckOrderGiftAndSamplers();
    }, 500),
    async getClientPrices() {
      const products = this.basket.map(basketItem => {
        return {
          id: basketItem.id,
          select_count: basketItem.select_count,
        }
      })
      await this.getClientPriceBasket(products);
    },

    async handleOrderClick() {
      await this.runCheckOrderGiftAndSamplers();
      if (this.hasUnselectedGifts) {
        this.changeSelectGiftPopup(true);
        return;
      }
      this.navigateTo("buy-flow-order");
    },
    hasTempDiscount() {
      return this.user && this.user.tempDiscount;
    },
    canSeeDiscount() {
      return this.user && (this.isUserWithCode || this.isProfessional || this.isDistributor);
    },
    syncProfessional() {
      this.updateUserAssignCode({ professional_id: this.kod })
        .then(() => {
          this.sync();
          this.$toasted.success(this.$t("successChangeCosmetolog"));
        })
        .catch(() => {
          this.$toasted.error(this.$t("errorCodeProfessional"));
        });
    },
    async sync() {
      const products = this.basket.map(basketItem => {
        return {
          id: basketItem.id,
          select_count: basketItem.select_count,
        }
      })
      await this.getSyncBasket(products);

      if (!this.isAuthenticated) {
        return;
      }

      await this.fetchUser();
      if (this.isUserWithCode || this.isProfessional || this.isDistributor) {
        const products = this.basket.map(basketItem => {
          return {
            id: basketItem.id,
            select_count: basketItem.select_count,
          }
        })
        await this.fetchDefaultPrices(products);
      }
    },
    updateWidth() {
      this.width = window.innerWidth;
    },
  },
  mounted() {
    window.addEventListener("resize", this.updateWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWidth);
  },
};
